import user from '../../api/user'
import * as mutation_types from '../mutation-types'
import * as action_types from '../action-types'
import Authorization from "@/authorization/Authorization";

// initial state
const state = {
    user: {
        name: '',
        surname: '',
        type: '',
        email: '',
        extra_data: '',
        school: {
            name: '',
            city: '',
            country: ''
        },
        permissions: {
            manage_admins: false,
            manage_survey_design: false,
            manage_survey_periods: false,
            manage_users: true,
            view_survey_design: false,
            switch_identity: false,
            edit_profile: false,
        },
        loaded: false,
    },
}

const actions = {

    [action_types.USER_LOAD] (context, {is_solo}) {

        // Collect user with his permissions from the API
        user.getUserWithPermissions({}, loaded_user => {
            if (is_solo) {

                // Solo has only one admin so the user has all permissions.
                for(let key in loaded_user.permissions){
                    // edurio/wiki#6848 - workaround to give solo accounts access to results
                    loaded_user.permissions[key] = key !== 'forbid_results_access';
                }
            }

            if (Authorization.token) {
                const tokenBody = JSON.parse(atob(Authorization.token.split('.')[1]))
                if (tokenBody && tokenBody.identity) {
                    loaded_user.permissions = Object.fromEntries(
                        Object.entries(loaded_user.permissions)
                            .map(([permissionName]) => [
                                permissionName,
                                tokenBody.identity.permissions.includes(permissionName)
                            ])
                    )
                }
            }

            loaded_user.loaded = true;
            context.commit(mutation_types.USER_SET, {user: loaded_user});
        });
    }
}

// mutations
const mutations = {
    [mutation_types.USER_SET] (state, {user}) {
        state.user = {...state.user, ...user};
    },

    [mutation_types.USER_NAME_SET] (state, name) {
        state.user.name = name;
    },

    [mutation_types.USER_SURNAME_SET] (state, surname) {
        state.user.surname = surname;
    },

    [mutation_types.USER_TYPE_SET] (state, type) {
        state.user.type = type;
    },
}

export default {
    state,
    actions,
    mutations
}
